import isDefined from '@afosto/utils/isDefined';

const getConfiguration = (integration, app) => {
  const configuration = { ...(integration?.configuration ?? {}) };

  if (app?.code === 'bol') {
    configuration.shipping_methods = isDefined(configuration?.shipping_methods)
      ? JSON.parse(atob(configuration.shipping_methods))
      : [];
  }

  if (app?.code === 'afosto') {
    configuration.channels = isDefined(configuration?.channels)
      ? JSON.parse(atob(configuration.channels))
      : [];

    configuration.shipping_methods = isDefined(configuration?.shipping_methods)
      ? JSON.parse(atob(configuration.shipping_methods))
      : [];
  }

  return configuration;
};

export default getConfiguration;
